/**
 * CMCD event mode variable name.
 *
 *
 * @beta
 */
export const CMCD_EVENT_MODE = 'event'
